export class UserData {
    useremail: string;
    isactive: boolean;
}

export class SecurityReport {
    RoleId: number;
    Name: string;
    Level: string;
    Email: string;
    Location: string;
    Function: string;
}

export class UserSecurityDetailCriteria {
    Name: string = "";
    Level: string = "";
    Email: string = "";
    Location: string = "";
    Function: string = "";
    CertificationlevelID: number = null;
    SortBy: string = "";
    SortOrder: string = null;
    PageNumber: number | null = 1;
    PageSize: number | null;
}

export class SecurityInfo {
    CountryId: number[];
    Email: string;
    RoleId: number;
    IsActive: boolean;
    IsCountryAdminModified: boolean;
}
export class BulkSecurityInfo {
    RoleId: number;
    ActionType: number;
    BulkUpdateUserFlag: UserData[];
}

export class UserInput {
    UserNameOrEmail: string
}

export class SecurityData {
    UserId: number;
    Name: string;
    Email: string;
    Country: string;
    ServiceFunction: string;
    Title: string;
    CertificationlevelID: number;
    FundamentalCertificationDate: string;
    IsFacilitator: boolean;
    IsGXFacilitator: boolean;
    IsXANonGX: boolean;
    IsSubscriptionAdmin: boolean;
    IsCountryAdmin: boolean;
    IsBC2: boolean;
    UserTopics: Array<UserTopics>;
    IsActiveTeamChemistry: boolean;
    ActiveTeamChemistryDate: string;
    IsProblemSolvingForBreakthrough: boolean;
    ProblemSolvingForBreakthroughDate: string;
    IsTrustFall: boolean;
    TrustFallDate: string;
    AssignedCountries: Array<string>;
    AuditTrails: Array<AuditTrail>;
    IsActive: boolean;
    PersonId: string; 
    CountryID: number;
    LevelID: number;
    ServiceFunctionID: number;
}

export class UserTopics {
    UserId: number;
    TopicId: number;
    TopicName: string;
    IsActive: boolean;
    Date: string;
    IsDateExists: string;
}

export class AuditTrail {
    ID:number;
    UserId: number;
    CreatedDate: string;
    FieldName: string;
    AuditTrail: string;
    Comments: string;
    CreatedBy: string;
    IsLatest: boolean;
}
export class UserSecurityPreviewData{
    UserID: number;
    Name: string;
    Title: string;
    Email: string;
    CountryID: number;
    Country: string;
    ServiceFunction: string;
    IsActive: boolean;
    IsEditable: boolean;
    Status: string;
    IsGXFacilitator: boolean;
}
export class UserDetails {
    FirstName: string;
    LastName: string;
    EmailAddress: string;

}